export enum ClubProgramStatus {
  Active = 'active',
  Paused = 'paused',
}

export interface IClubTopUpPlan {
  amount: number;
  bonus: number;
}

export interface IClubProgram {
  id: number;
  restaurantId: number;
  status: ClubProgramStatus;
  name: string;
  pointsEnabled: boolean;
  earnUnitAmount: number;
  earnPoints: number;
  redeemPointsCost: number;
  redeemValue: number;
  minRedeemPoints: number;
  maxRedeemPercent: number;
  pointsExpiryMonths: number | null;
  welcomePoints: number;
  balanceEnabled: boolean;
  topUpPlans: IClubTopUpPlan[] | null;
  minTopUp: number;
  maxMemberBalance: number | null;
  branchIds: number[] | null;
  termsText: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * Public program projection attached to the restaurant /full payload
 * (only active programs on entitled plans; no restaurantId/timestamps).
 */
export interface IClubProgramPublic {
  id: number;
  status: ClubProgramStatus;
  name: string;
  pointsEnabled: boolean;
  earnUnitAmount: number;
  earnPoints: number;
  redeemPointsCost: number;
  redeemValue: number;
  minRedeemPoints: number;
  maxRedeemPercent: number;
  pointsExpiryMonths: number | null;
  welcomePoints: number;
  balanceEnabled: boolean;
  topUpPlans: IClubTopUpPlan[] | null;
  minTopUp: number;
  maxMemberBalance: number | null;
  branchIds: number[] | null;
  termsText: string | null;
}

export interface IUpsertClubProgramDto {
  name: string;
  status?: ClubProgramStatus;
  pointsEnabled: boolean;
  earnUnitAmount: number;
  earnPoints: number;
  redeemPointsCost: number;
  redeemValue: number;
  minRedeemPoints?: number;
  maxRedeemPercent?: number;
  pointsExpiryMonths?: number | null;
  welcomePoints?: number;
  balanceEnabled: boolean;
  topUpPlans?: IClubTopUpPlan[] | null;
  minTopUp?: number;
  maxMemberBalance?: number | null;
  branchIds?: number[] | null;
  termsText?: string | null;
}
